import { combineReducers } from '@reduxjs/toolkit';
import { createAction } from '@reduxjs/toolkit';

import announcementSlice from '../Slices/AnnouncementsSlice/index';
import AuthSlice from '../Slices/AuthSlice';
import cloudPrep from '../Slices/CloudPrepSlice';
import AddQuestion from '../Slices/CMS/AddQuestionSlice';
import dataReviewerSlice from '../Slices/CMS/DataReviewerSlice';
import headerSlice from '../Slices/headerSlice';
import interviewSlice from '../Slices/InterviewSlice';
import paymentsSlice from '../Slices/PaymentsSlice';
import programming from '../Slices/ProgrammingSlice';
import questionBankSlice from '../Slices/QuestionBankSlice';
import questionSlice from '../Slices/QuestionsSlice';
import registration from '../Slices/registrationSlice';
import resumeSlice from '../Slices/ResumeSlice';
import scheduleTest from '../Slices/ScheduleTestSlice';
import completeTestData from '../Slices/StartTestSlice/completeTestData';
import newTempleteSlice from '../Slices/StartTestSlice/newTemplete';
import startFullTest from '../Slices/StartTestSlice/startFulTest';
import tagsSlice from '../Slices/tags';

import ResultsSlice from './../Slices/ResultsSlice/ResultsSlice';
export const resetApp = createAction('app/reset');

const appReducer = combineReducers({
  header: headerSlice,
  auth: AuthSlice,
  questions: questionSlice,
  addQuestion: AddQuestion,
  questionBank: questionBankSlice,
  dataReviewer: dataReviewerSlice,
  newTemplete: newTempleteSlice,
  startFulltest: startFullTest,
  interview: interviewSlice,
  payments: paymentsSlice,
  results: ResultsSlice,
  completeTestData,
  programming,
  registration,
  cloudPrep,
  announcementSlice,
  scheduleTest,
  tags: tagsSlice,
  resume: resumeSlice
});

const rootReducer = (state: any, action: any) => {
  if (action.type === resetApp.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
